import React from 'react';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';

import Loader from 'crehana-ui/Loader';
import customSessionStorage from 'Utils/customSessionStorage';
import useDisclosure from 'Shared/Hooks/useDisclosure';
import Loadable from 'Shared/Loadable';
import useMe from 'Shared/Hooks/useMe';

const useMembershipRenovation = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [canRender, setCanRender] = React.useState(false);
  const [remainingDays, setRemainingDays] = React.useState<number>(0);

  const { me } = useMe();

  React.useEffect(() => {
    const user = me;


    if (
      user &&
      user.membership &&
      ['null', 'true', '"true"'].includes(
        JSON.stringify(
          customSessionStorage.getItem(
            'RENOVATION_MEMBERSHIP_DIALOG__bannerVisibility',
          ),
        ),
      )
    ) {
      // Does his membership has 30 days remaining or less?
      const THRESHOLD_REMAINING_DAYS = 30;
      const REMAINING_DAYS = differenceInCalendarDays(
        new Date(user.membership.expireDate),
        new Date(),
      );
      const isMembershipAutorenovationActive =
        user.membership.isSubscriptionCanceled;

      if (
        REMAINING_DAYS <= THRESHOLD_REMAINING_DAYS &&
        isMembershipAutorenovationActive
      ) {
        setCanRender(true);
        setRemainingDays(REMAINING_DAYS);
      }
    }
  }, [me]);

  return {
    canRender,
    remainingDays,
    isOpen,
    showRenovationDialog: () => {
      onOpen();
    },
    closeRenovationDialog: () => {
      onClose();
    },
    MembershipRenovationDialog: (
      <Loadable
        module={() =>
          import(
            /* webpackChunkName: "membership-renovation-dialog" */ 'Jsx/Shared/MembershipRenovationDialog'
          )
        }
        isOpen={isOpen}
        closeDialog={() => {
          onClose();
        }}
        Loader={
          <div className="w-full flex justify-center items-center">
            <Loader size={32} />
          </div>
        }
      />
    ),
  };
};

export default useMembershipRenovation;
